import { errorValidation, maskList, geoIpLookup } from './utils';

/**
 * Validate forms
 */
function initializeBookValidation(bookPhone) {
	/**
	 * Init intlTelInput
	 */
	if (bookPhone.length) {
		let phones_exist = false;
		[bookPhone].forEach(phoneInput => {
			var phoneValue = phoneInput.val();
			if (phoneValue) {
				phones_exist = true;
				setTimeout(function () {
					phoneInput.val(phoneValue);
				}, 500);
			}
		});
		if (!phones_exist) {
			setTimeout(function () {
				geoIpLookup(countryCode => {
					[bookPhone].forEach(phoneInput => {
						phoneInput.intlTelInput('setCountry', countryCode.toLowerCase());
						const maskObj = maskList.find(mask => {
							return (
								mask.cc &&
								typeof mask.cc === 'string' &&
								mask.cc.toLowerCase() === countryCode.toLowerCase()
							);
						});
						if (maskObj) {
							console.log(`Applying mask for ${maskObj.cc}: ${maskObj.mask}`);
							phoneInput.inputmask('remove');
							phoneInput.inputmask({ mask: maskObj.mask });
						}
					});
				});
			}, 500);
		}

		[bookPhone].forEach(phoneInput => {
			phoneInput.intlTelInput({
				initialCountry: 'auto', // Automatically detect the country
				placeholderNumberType: 'aggressive',
				utilsScript:
					'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.14/js/utils.js',
				separateDialCode: false,
				allowDropdown: false,
			});

			phoneInput.inputmasks({
				inputmask: {
					definitions: {
						'#': {
							validator: '[0-9]',
							cardinality: 1,
						},
					},
					//clearIncomplete: false,
					showMaskOnHover: false, // Show mask
					autoUnmask: true, // Remove country code when input is empty
				},
				match: /[0-9]/,
				replace: '#',
				list: maskList,
				listKey: 'mask',
				onMaskChange: function (maskObj, completed) {
					if (maskObj) {
						console.log(`Applying mask for ${maskObj.cc}: ${maskObj.mask}`);
						let countryCode = Array.isArray(maskObj.cc)
							? maskObj.cc[0].toLowerCase()
							: maskObj.cc.toLowerCase();
						phoneInput.intlTelInput('setCountry', countryCode);
					} else {
						console.log(`No mask found, applying default mask`);
						phoneInput.inputmask({ mask: '9999999999' }); // Fallback mask
					}
				},
			});

			// On blur: validate phone number
			phoneInput.focusout(function () {
				if ($.trim(phoneInput.val())) {
					if (phoneInput.intlTelInput('isValidNumber')) {
						console.log('isValidNumber');
					} else {
						phoneInput.addClass('_error');
					}
				}
			});

			// On keydown: reset
			phoneInput.keydown(function () {
				phoneInput.removeClass('_error');
			});
		});
	}

	/**
	 * Add custom validation method
	 */
	$.validator.addMethod(
		'validateBookPhone',
		function () {
			if (bookPhone.intlTelInput('isValidNumber')) {
				return true;
			} else {
				return false;
			}
		},
		window.translations.phoneInvalid
	);

	// Book
	$("form[name='book']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'book[name]': {
				required: true,
			},
			'book[phone]': {
				required: true,
				validateBookPhone: true,
			},
			'book[truck_number]': {
				required: true,
			},
			'book[trailer_number]': {
				required: true,
			},
			'book[location_empty]': {
				required: true,
			},
			'book[date_empty]': {
				required: true,
			},
			'book[time_empty]': {
				required: true,
			},
		},
		messages: {
			'book[name]': {
				required: window.translations.required,
			},
			'book[phone]': {
				required: window.translations.required,
			},
			'book[truck_number]': {
				required: window.translations.required,
			},
			'book[trailer_number]': {
				required: window.translations.required,
			},
			'book[location_empty]': {
				required: window.translations.required,
			},
			'book[date_empty]': {
				required: window.translations.required,
			},
			'book[time_empty]': {
				required: window.translations.required,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
}

$(document).on('click', '.get__book', function (e) {
	e.preventDefault();
	const load_id = $(this).data('load_id');
	const connection_id = $(this).closest('.connection_container').data('id');
	const full = $(this).data('full');

	addLoader('.custom__loader', 800, { height: '250px' }, function () {
		$.ajax({
			url: '/' + lang + '/book/get', // путь к обработчику
			type: 'POST', // метод отправки,
			dataType: 'json',
			data: {
				load_id: load_id,
				connection_id: connection_id,
				full: full,
			},
			success: function (data) {
				if (data.status == 'ok') {
					$('.add_book_container').remove();
					$('.wrapper').append(data.view);
					let bookPhone = $('#book_phone');

					initializeBookValidation(bookPhone);
					AttachPopup();
					AttachPlaceholder();

					var phoneNumber = bookPhone.val();
					if (phoneNumber) {
						setTimeout(function () {
							bookPhone.val(phoneNumber);
						}, 500);
					}
				}
			},
			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	});
});

$(document).on('click', '.add__book', function (event) {
	event.preventDefault();
	let book_form = $("form[name='book']");

	if (book_form.valid()) {
		let book = book_form.serializeArray();

		let allData = {};
		$.each(book, function (index, field) {
			allData[field.name] = field.value;
		});

		console.log('allData: ', allData);

		addLoader('.custom__loader', 800, { height: '250px' }, function () {
			$.ajax({
				url: '/' + lang + '/book/add', // путь к обработчику
				type: 'POST', // метод отправки,
				dataType: 'json',
				data: allData,
				success: function (data) {
					if (data.status == 'ok') {
						$('.add_book_container').replaceWith(data.view);
						AttachPopup();
					} else {
						$('.add_book_container').replaceWith(data.view);
						AttachPopup();
					}
				},
				error: function (data) {
					console.log(data); // выводим ошибку в консоль
				},
			});
		});
	}
});
